/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or
  substantial portions of the Software.

*/
// reactstrap components
import React from 'react';
import {
  Button, Row, Col
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Account config
import config from 'config';

export default function ProfileHeader() {
  // Get history
  const history = useHistory();

  const account = useSelector((state) => state.account);

  return (
    <Row
      style={{
        minHeight: '200px',
        backgroundImage: `url(${config.assets.img.brand.backgrounds.profile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        padding: '32px 8px',
        margin: '0'
      }}
    >
      <Col>
        {/* <h1 className="display-2 text-white">
                Hello
                {profile.initialized && profile.user.details.firstName
                  ? ` ${profile.user.details.firstName}`
                  : ``}
              </h1> */}
        <h1 className="display-2 text-white">
          Customer Persona Overview
        </h1>
        <p className="text-white mt-0 mb-5" />
        <Button
          className="bg-gradient-primary"
          color="default"
          href=""
          onClick={(e) => {
            // Send back to home
            history.push('/admin/customers/acquisition');
          }}
        >
          Customer Performance
        </Button>
        <Button className="bg-transparent border border-primary">
          Active Campaigns
        </Button>
        {
          account
              && account.initialized
              && account.active
              && account.active.access
              && account.active.access.campaigns
            ? (
              <Button
                className="btn-info"
                color="default"
                href=""
                onClick={(e) => {
                  // Send back to home
                  history.push('/admin/campaigns');
                }}
              >
                Active Campaigns
              </Button>
            ) : (
              null
            )
        }
      </Col>
    </Row>
  );
}
